import React from "react";

import "./Loader.scss";

interface LoaderProps {
    disabled?: boolean,
    useMask?: boolean,
    overlay?: boolean
}

class Loader extends React.Component<LoaderProps> {

    render() {
        
        return (
        <div className={`loading${this.props.useMask ? " loader-mask" : ""}${this.props.overlay ? " overlay" : ""}`}>
            <div className="loader"></div>
        </div>
        );

    }

}

export default Loader;